import React, { HTMLAttributeAnchorTarget } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import './App.css';

import MainLayout from './layouts/MainLayout';
import BitRageDetailView from './views/explore-product/bitRageDetailView';
import MarketMakerDetailView from './views/explore-product/MarketMakerDetailView';
import ProEditionDetailView from './views/explore-product/ProEditionDetailView';
import StandardEditionDetailView from './views/explore-product/StandardEditionDetailView';
import UltimateEditionDetailView from './views/explore-product/UltimateEditionDetailView';
import Home from './views/home';
import BitRageView from './views/products/BitRageView';
import GunbotView from './views/products/GunbotView';
import MarketMakerView from './views/products/MarketMakerView';
import BecomeAnAfilliateView from './views/shops/BecomeAnAfilliateView';
import WorldWideShopsView from './views/shops/WorldWideShopsView';
import Statistics from './views/home/stats';
import Downloads from './views/home/downloads';

export type RouteOptionProps = {
  title: string;
  path?: string;
  element?: JSX.Element;
  external?: boolean;
  target?: HTMLAttributeAnchorTarget;
  sub_routes?: RouteOptionProps[];
};

export const routes: RouteOptionProps[] = [
  {
    title: 'Products',
    sub_routes: [
      { title: 'Gunbot', path: '/gunbot', element: <GunbotView /> },
      { title: 'bitRage', path: '/bitrage', element: <BitRageView /> },
      { title: 'Market Maker', path: '/market-maker', element: <MarketMakerView /> },
    ],
  },
  {
    title: 'Resources',
    sub_routes: [
      { title: 'Wiki', path: 'https://wiki.gunthy.org', target: '_blank', external: true },
      { title: 'Forum', path: 'https://forum.gunthy.org', target: '_blank', external: true },
      { title: 'Blog', path: 'https://viraltrading.org', target: '_blank', external: true },
      { title: 'Marketplace', path: 'https://marketplace.gunthy.io', target: '_blank', external: true },
    ],
  },
  {
    title: 'Shops',
    sub_routes: [
      { title: 'World Wide Shops', path: '/resellers', element: <WorldWideShopsView /> },
      { title: 'Become An Affiliate', path: '/affiliate', element: <BecomeAnAfilliateView /> },
    ],
  },
  {
    title: 'Downloads',
    path: '/downloads',
    element: <Downloads />,
  },
];

const mainRoutes: RouteOptionProps[] = [];
routes.forEach(route => {
  route.sub_routes?.forEach(_route => {
    if (_route.element) {
      mainRoutes.push(_route);
    }
  });
});

function App() {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route path="/downloads" element={<Downloads />} /> </Route>
    </Routes>
  );
}

export default App;
